import {Vue} from 'ui.vue';

export let CatalogSectionSimilar = {
	name: 'CatalogSectionSimilar',
	data: function () {
		return {
			settings:{
				title: '',
				url: '',
				sliderHasBtn: true,
			},
			slider: null,
			products: [],
			swiperOption: {
				slidesPerView: 5,
				spaceBetween: 20,
				breakpoints: {
					1750: {
						slidesPerView: 4,
					},
					1400: {
						slidesPerView: 3,
					},
					850: {
						slidesPerView: 2,
					},
					600: {
						slidesPerView: 1,
					},
				},
				navigation: {
					nextEl: 'swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
			},
			loading: false,
			isShowProductDescription: true
		};
	},
	mixins: [BX.Citrus.Vue.Component.BulletsRestClient],
	created() {
		this.getBulletsInfo(this.products, "BULLETS");
	},
	mounted () {

		this.swiperOption.navigation.nextEl = this.$options.el + " .swiper-button-next";
		this.swiperOption.navigation.prevEl = this.$options.el + " .swiper-button-prev";

		this.slider = new Swiper(this.$refs.similarProducts, this.swiperOption);
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("SIMILAR_CATALOG_SECTION_");
		},
	},
};

export default {CatalogSectionSimilar};